import { Badge } from "@/components/ui/badge"
import { DishIllustration } from "./dish-illustration"
import { DishPrice, DishPromotionBadge } from "./dish-price"
import type { MenuItem } from "./types"
import { t } from "@/lib/i18n"

type FeaturedCardProps = {
  item: MenuItem
  onSelect: (item: MenuItem) => void
}

export function FeaturedCard({ item, onSelect }: FeaturedCardProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(item)}
      data-testid={`featured-card-${item.id}`}
      className="flex w-52 shrink-0 flex-col overflow-hidden rounded-xl border bg-card text-left text-foreground shadow-xs transition-transform active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:w-full"
    >
      <div className="relative h-28">
        <DishIllustration src={item.imageUrl} emoji={item.emoji} alt={item.name} />
        <Badge variant="secondary" className="absolute left-2 top-2">
          {t("ui.react.features.user.featured_card.recommended")}
        </Badge>
      </div>
      <div className="space-y-1 px-3 pb-3 pt-2.5">
        <div className="flex items-baseline justify-between gap-2">
          <span className="min-w-0 truncate text-sm font-semibold leading-tight tracking-tight">
            {item.name}
          </span>
          {/* The card is 208px wide and the promoted pair is two figures, so
              they get the whole row rather than the remainder of the name's.
              `shrink-0` on a two-figure price would push the name to an
              ellipsis on every promoted card. */}
          <DishPrice item={item} className="shrink-0" />
        </div>
        <DishPromotionBadge item={item} className="flex w-fit" />
      </div>
    </button>
  )
}
